import React from 'react';

const CandidateCareer: React.FC = () => {
    const cards = [
        {
            icon: '/career/upload.svg',
            title: 'Upload Your Resume',
            description: 'Quick, secure, and private.'
        },
        {
            icon: '/career/goals.svg',
            title: 'Share Career Goals',
            description: 'Let David, our AI recruiter know what you\'re looking for in your next role!'
        },
        {
            icon: '/career/ai_matching.svg',
            title: 'AI Matchmaking',
            description: 'David will share only the top fits with you and you can engage directly when you\'re interested'
        },
        {
            icon: '/career/connect.svg',
            title: 'Connect & Interview',
            description: 'Interviews and pipeline handled automatically.'
        }
    ];

    return (
        <section className="relative px-4 pt-4 pb-4 sm:pt-10 sm:pb-10 overflow-x-hidden">
            <div className="container mx-auto max-w-[1640px]">
                {/* Section Title */}
                <h2
                    className="text-left mb-8 sm:mb-16"
                    style={{
                        fontFamily: 'Manrope',
                        fontStyle: 'normal',
                        fontWeight: 700,
                        fontSize: 'clamp(32px, 7vw, 104px)',
                        lineHeight: 'clamp(38px, 8vw, 128px)',
                        letterSpacing: '-0.05em',
                        color: '#FFFFFF',
                    }}
                >
                    Your career, simplified
                </h2>

                {/* Cards Grid */}
                <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 max-w-[1600px] mx-auto">
                    {cards.map((card, index) => (
                        <div
                            key={index}
                            className="w-full"
                            style={{
                                boxSizing: 'border-box',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                padding: 'clamp(16px, 4vw, 32px) clamp(12px, 3vw, 24px)',
                                gap: 'clamp(12px, 3vw, 20px)',
                                maxWidth: '379px',
                                minHeight: 'clamp(200px, 30vw, 280px)',
                                background: 'rgba(20, 30, 48, 0.6)',
                                border: '1px solid rgba(255, 255, 255, 0.1)',
                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.3)',
                                backdropFilter: 'blur(20px)',
                                borderRadius: 'clamp(16px, 4vw, 24px)',
                                margin: '0 auto'
                            }}
                        >
                            {/* Icon */}
                            <img
                                src={card.icon}
                                alt={card.title}
                                style={{
                                    width: 'clamp(48px, 12vw, 80px)',
                                    height: 'clamp(48px, 12vw, 80px)',
                                    objectFit: 'contain',
                                    flex: 'none',
                                    order: 0,
                                    flexGrow: 0
                                }}
                            />

                            {/* Title */}
                            <h3
                                style={{
                                    width: '100%',
                                    fontFamily: 'Manrope',
                                    fontStyle: 'normal',
                                    fontWeight: 600,
                                    fontSize: 'clamp(14px, 3vw, 20px)',
                                    lineHeight: 'clamp(18px, 4vw, 28px)',
                                    textAlign: 'center',
                                    letterSpacing: '-0.01em',
                                    color: '#FFFFFF',
                                    margin: 0,
                                    flex: 'none',
                                    order: 1,
                                    flexGrow: 0
                                }}
                            >
                                {card.title}
                            </h3>

                            {/* Description */}
                            <p
                                style={{
                                    width: '100%',
                                    fontFamily: 'Manrope',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    fontSize: 'clamp(11px, 2.5vw, 14px)',
                                    lineHeight: 'clamp(16px, 3vw, 20px)',
                                    textAlign: 'center',
                                    letterSpacing: '0em',
                                    color: 'rgba(255, 255, 255, 0.7)',
                                    margin: 0,
                                    flex: 'none',
                                    order: 2,
                                    flexGrow: 0
                                }}
                            >
                                {card.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CandidateCareer;
